module.exports = __webpack_public_path__ + "img/mal.0b61cf51.svg";